const LeadFormIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="4.75"
            y="2.75"
            width="14.5"
            height="18.5"
            rx="2.25"
            stroke="#92A8DF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="7.75"
            y="5.75"
            width="8.5"
            height="3.5"
            rx="1.75"
            stroke="#92A8DF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="7.75"
            y="11.75"
            width="8.5"
            height="3.5"
            rx="1.75"
            stroke="#92A8DF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M10 18H14" stroke="#92A8DF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export default LeadFormIcon
